import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateToThunk } from '../../core/navigation/navigationSlice.js';
import { showModalThunk } from './modalSlice.js';
import { dynamicMiddleware } from '../../index.js';
let modalNavigationMiddlewareInstance;
const modalNavigationMiddlewareOptions = {
    actionCreator: navigateToThunk.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        listenerApi.dispatch(showModalThunk(action.payload));
    },
};
const addModalNavigationMiddleware = () => {
    modalNavigationMiddlewareInstance = createListenerMiddleware();
    modalNavigationMiddlewareInstance.startListening(modalNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(modalNavigationMiddlewareInstance.middleware);
};
const removeModalNavigationMiddleware = () => {
    if (modalNavigationMiddlewareInstance) {
        dynamicMiddleware.removeMiddleware(modalNavigationMiddlewareInstance.middleware);
        modalNavigationMiddlewareInstance = null;
    }
};
export const modalNavigationMiddleware = {
    add: addModalNavigationMiddleware,
    remove: removeModalNavigationMiddleware,
};
//# sourceMappingURL=modalNavigationMiddleware.js.map